module.exports = __webpack_public_path__ + "img/GY.c4c787e0.svg";